export default "__VITE_ASSET__19bd2d8e__"